import React, { createContext, useContext, useState, useMemo } from 'react';
import { useQuery, gql } from '@apollo/client';

const GET_MY_KITCHEN_DETAILS = gql`
  query GetMyKitchenDetails {
    getMyKitchenDetails {
      kitchenId
      kitchenName
      kitchenStatus
      kitchenColor
      modelName
      modelDimension
      noOfNutripot
      noOfInduction
      noOfSpiceDispenser
      noOfGrainDispenser
      noOfManualStationCup
      noOfManualStationBowl
      isInventoryAvailable
      inventory
    }
  }
`;


// Create context with default values to prevent undefined errors
const KitchenDetailContext = createContext({
  kitchenDetail: null,
  loading: false,
  error: null,
  refetch: () => {}
});

export const KitchenDetailProvider = ({ children }) => {
  const [kitchenDetail, setKitchenDetail] = useState(null);
  const { loading, error, data, refetch } = useQuery(GET_MY_KITCHEN_DETAILS);
console.log(data,error);
  React.useEffect(() => {

    if (data) {
      setKitchenDetail(data.getMyKitchenDetails);
    }
  }, [data]);

  // Use useMemo to prevent unnecessary re-renders
  const contextValue = useMemo(() => ({
    kitchenDetail,
    loading,
    error,
    refetch
  }), [kitchenDetail, loading, error, refetch]);

  return (
    <KitchenDetailContext.Provider value={contextValue}>
      {children}
    </KitchenDetailContext.Provider>
  );
};

export const useKitchenDetail = () => useContext(KitchenDetailContext);
